import {
    getSustainableGoals,
    getUserProjects,
} from '../domains/projects/service';

const getMainSdg = async (userId) => {
    const getSdg = await getSustainableGoals();
    const { data } = await getUserProjects(userId);

    const projects = data._embedded.public_carbon_project;

    const sdg = getSdg.data._embedded.sustainable_development_goal;

    const mainSDG = projects.reduce((acc, curr) => {
        sdg.map((sdg) => {
            if (curr.selectedSDG === sdg.id) {
                acc[curr.selectedSDG] = curr.selectedSDG;

                return acc;
            }

            return acc;
        });

        return acc;
    }, {});

    localStorage.setItem('mainSDG', JSON.stringify(mainSDG));
};

export default getMainSdg;
